import { ICompanyInterface } from 'Interfaces/ICompaniesConfig';

import { initialCompanyState } from 'pages/Companies/CompanyForm';



type CompanyAction =
  | { type: 'SET_COMPANY'; payload: ICompanyInterface }
;

export const CompanyReducer = (
  state: ICompanyInterface = initialCompanyState,
  action: CompanyAction
): ICompanyInterface => {
  switch (action.type) {
    case 'SET_COMPANY':
      console.log('ghg SET_COMPANY', action.payload);
      return {
        ...state,
        ...action.payload,   
      };     
    default:
      return state;
  }
};
